<template>
  <div class="page-loader" role="status" aria-label="Loading">
    <app-spinner />
  </div>
</template>

<script>
export default {
  name: 'AppPageLoader',
}
</script>

<style lang="sass" scoped>
.page-loader
  position: absolute
  inset: 0
  z-index: 2
  background: var(--page-loader-background, #fff)

</style>
